import {
  AuditLog,
  AuditAction,
  EntityType,
  AuditSeverity,
  AuditCategory,
  AuditChange,
  ChangeType,
} from '../models/audit-log.model';

export const MOCK_AUDIT_LOGS: AuditLog[] = [
  {
    id: 1,
    userId: 1,
    sessionId: 1001,
    action: AuditAction.LOGIN,
    entityType: EntityType.USER,
    entityId: 1,
    ipAddress: '192.168.1.100',
    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36',
    timestamp: new Date('2024-01-17T08:30:00Z'),
    severity: AuditSeverity.LOW,
    category: AuditCategory.AUTHENTICATION,
    descriptionKey: 'audit.user-login-success',
    description: 'audit.user-login-success',
    isSuccess: true,
    duration: 150,
    resource: '/api/auth/login',
    method: 'POST',
    statusCode: 200,
  },
  {
    id: 2,
    userId: 3,
    sessionId: 1002,
    action: AuditAction.CREATE,
    entityType: EntityType.REQUEST,
    entityId: 1,
    oldValues: {},
    newValues: {
      title: 'Leaky Faucet in Kitchen',
      description: 'The kitchen faucet has been dripping continuously',
      status: 'pending',
      priority: 'medium',
    },
    changes: [
      {
        field: 'title',
        oldValue: null,
        newValue: 'Leaky Faucet in Kitchen',
        changeType: ChangeType.ADDED,
      },
      {
        field: 'status',
        oldValue: null,
        newValue: 'pending',
        changeType: ChangeType.ADDED,
      },
    ],
    ipAddress: '192.168.1.101',
    userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36',
    timestamp: new Date('2024-01-15T10:30:00Z'),
    severity: AuditSeverity.MEDIUM,
    category: AuditCategory.DATA_MODIFICATION,
    descriptionKey: 'audit.new-maintenance-request-created',
    description: 'audit.new-maintenance-request-created',
    isSuccess: true,
    duration: 250,
    resource: '/api/requests',
    method: 'POST',
    statusCode: 201,
  },
  {
    id: 3,
    userId: 1,
    sessionId: 1001,
    action: AuditAction.UPDATE,
    entityType: EntityType.REQUEST,
    entityId: 1,
    oldValues: {
      status: 'pending',
      assignedTo: null,
    },
    newValues: {
      status: 'in_progress',
      assignedTo: 'John Smith',
    },
    changes: [
      {
        field: 'status',
        oldValue: 'pending',
        newValue: 'in_progress',
        changeType: ChangeType.MODIFIED,
      },
      {
        field: 'assignedTo',
        oldValue: null,
        newValue: 'John Smith',
        changeType: ChangeType.ADDED,
      },
    ],
    ipAddress: '192.168.1.100',
    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36',
    timestamp: new Date('2024-01-15T11:15:00Z'),
    severity: AuditSeverity.MEDIUM,
    category: AuditCategory.DATA_MODIFICATION,
    descriptionKey: 'audit.request-status-updated-assigned',
    description: 'audit.request-status-updated-assigned',
    isSuccess: true,
    duration: 180,
    resource: '/api/requests/1',
    method: 'PUT',
    statusCode: 200,
  },
  {
    id: 4,
    userId: 2,
    sessionId: 1003,
    action: AuditAction.LOGIN_FAILED,
    entityType: EntityType.USER,
    entityId: 2,
    ipAddress: '192.168.1.102',
    userAgent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 15_0 like Mac OS X) AppleWebKit/605.1.15',
    timestamp: new Date('2024-01-16T14:20:00Z'),
    severity: AuditSeverity.HIGH,
    category: AuditCategory.SECURITY,
    descriptionKey: 'audit.failed-login-attempt',
    description: 'audit.failed-login-attempt',
    isSuccess: false,
    errorMessageKey: 'audit.invalid-username-password',
    errorMessage: 'audit.invalid-username-password',
    duration: 50,
    resource: '/api/auth/login',
    method: 'POST',
    statusCode: 401,
  },
  {
    id: 5,
    userId: 1,
    sessionId: 1001,
    action: AuditAction.DELETE,
    entityType: EntityType.REQUEST,
    entityId: 5,
    oldValues: {
      id: 5,
      title: 'Garbage Disposal Repair',
      status: 'pending',
    },
    newValues: {},
    changes: [
      {
        field: 'id',
        oldValue: 5,
        newValue: null,
        changeType: ChangeType.REMOVED,
      },
      {
        field: 'title',
        oldValue: 'Garbage Disposal Repair',
        newValue: null,
        changeType: ChangeType.REMOVED,
      },
    ],
    ipAddress: '192.168.1.100',
    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36',
    timestamp: new Date('2024-01-15T10:15:00Z'),
    severity: AuditSeverity.MEDIUM,
    category: AuditCategory.DATA_MODIFICATION,
    descriptionKey: 'audit.request-cancelled-deleted',
    description: 'audit.request-cancelled-deleted',
    isSuccess: true,
    duration: 120,
    resource: '/api/requests/5',
    method: 'DELETE',
    statusCode: 200,
  },
  {
    id: 6,
    userId: 4,
    sessionId: 1004,
    action: AuditAction.PASSWORD_CHANGE,
    entityType: EntityType.USER,
    entityId: 4,
    oldValues: {},
    newValues: {},
    changes: [
      {
        field: 'password',
        oldValue: '[HIDDEN]',
        newValue: '[HIDDEN]',
        changeType: ChangeType.MODIFIED,
      },
    ],
    ipAddress: '192.168.1.103',
    userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36',
    timestamp: new Date('2024-01-14T16:45:00Z'),
    severity: AuditSeverity.MEDIUM,
    category: AuditCategory.SECURITY,
    descriptionKey: 'audit.user-changed-password',
    description: 'audit.user-changed-password',
    isSuccess: true,
    duration: 200,
    resource: '/api/users/4/password',
    method: 'PUT',
    statusCode: 200,
  },
  {
    id: 7,
    userId: 1,
    sessionId: 1001,
    action: AuditAction.CONFIGURATION_CHANGE,
    entityType: EntityType.SYSTEM,
    entityId: undefined,
    oldValues: {
      maintenanceMode: false,
      maxLoginAttempts: 5,
    },
    newValues: {
      maintenanceMode: true,
      maxLoginAttempts: 3,
    },
    changes: [
      {
        field: 'maintenanceMode',
        oldValue: false,
        newValue: true,
        changeType: ChangeType.MODIFIED,
      },
      {
        field: 'maxLoginAttempts',
        oldValue: 5,
        newValue: 3,
        changeType: ChangeType.MODIFIED,
      },
    ],
    ipAddress: '192.168.1.100',
    userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36',
    timestamp: new Date('2024-01-18T02:00:00Z'),
    severity: AuditSeverity.HIGH,
    category: AuditCategory.CONFIGURATION,
    descriptionKey: 'audit.system-configuration-updated',
    description: 'audit.system-configuration-updated',
    isSuccess: true,
    duration: 300,
    resource: '/api/system/config',
    method: 'PUT',
    statusCode: 200,
  },
  {
    id: 8,
    userId: undefined,
    sessionId: undefined,
    action: AuditAction.SYSTEM_STARTUP,
    entityType: EntityType.SYSTEM,
    entityId: undefined,
    ipAddress: '127.0.0.1',
    userAgent: 'System',
    timestamp: new Date('2024-01-15T06:00:00Z'),
    severity: AuditSeverity.LOW,
    category: AuditCategory.SYSTEM_OPERATION,
    descriptionKey: 'audit.system-startup-completed',
    description: 'audit.system-startup-completed',
    isSuccess: true,
    duration: 5000,
    resource: '/system/startup',
    method: 'SYSTEM',
    statusCode: 200,
  },
];
